import { render, staticRenderFns } from "./DCategorySelector.vue?vue&type=template&id=3dcd4f25&scoped=true&"
import script from "./DCategorySelector.vue?vue&type=script&lang=js&"
export * from "./DCategorySelector.vue?vue&type=script&lang=js&"
import style0 from "./DCategorySelector.vue?vue&type=style&index=0&id=3dcd4f25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcd4f25",
  null
  
)

export default component.exports